import { useEffect, useState } from "react"
import urlApi from "shared/actions/urlApi";
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam"


export const useGetLMSImage = (team?: ComputedTeam): File[] => {
    const [images, setImages] = useState<File[]>([]);

    useEffect(() => {
        if (images?.length === 0) {
            setImages(JSON.parse(team?.additionalInfo?.lmstitleimage || "[]"))
        }
    }, [team])

    return images;
}import { useEffect, useState } from "react"
import urlApi from "shared/actions/urlApi";
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam"


export const useGetLMSImage = (team?: ComputedTeam): File[] => {
    const [images, setImages] = useState<File[]>([]);

    useEffect(() => {
        if (images?.length === 0) {
            setImages(JSON.parse(team?.additionalInfo?.lmstitleimage || "[]"))
        }
    }, [team])

    return images;
}